import type {
  CourseCardCourse,
  TrailerSource,
} from '@crehana/web/Graphql/types/Course';

import type { Course } from './types';

const ParseMetricsCourse = (course: Course): CourseCardCourse => ({
  originalId: Number(course.originalId),
  url: null,
  promoImage: course.promoImage || '',
  trailerSources: (course.trailerSource as TrailerSource[]) || [],
  enrollmentUrl: null,
  dashboardUrl: null,
  courseType: null,
  isSavedCourse: false,
  courseTag: course.courseTag,
  level: {
    ...course.level,
    originalId: null,
    slug: course.level?.slug!,
    name: course.level?.name!,
  },
  score: course.score,
  professor: {
    ...course.professor,
    originalId: null,
    username: course.professor?.username!,
    fullName: course.professor?.fullName!,
  },
  prices: null,
  subtitleList: [],
  urlToBuyNow: null,
  duration: course.duration,
  title: course.title,
  preSale: course.preSale,
  isEnrollment: false,
  description: course.shortDescriptionWithoutHtml,
  launchDate: null,
  totalLessons: null,
  imagePlaceholder: null,
  enrollments: course.enrollments,
  catalogCategories: [],
  enrollmentAccessPreviewUrl: null,
});

export default ParseMetricsCourse;
